export const TABLE_IDS = {
  CASINO_TRANSACTIONS: 'casinoTransactions',
  USER_CASINO_TRANSACTIONS: 'userCasinoTransactions',
  FINANCIAL_TRANSACTIONS: 'financialTransactions',
  USER_FINANCIAL_TRANSACTIONS: 'userFinancialTransactions'
}

export const CASINO_TRANSACTIONS_COLUMNS = [
  { id: 'casinoTransactionId', label: 'ID', show: true },
  { id: 'roundId', label: 'Round Id', show: true },
  { id: 'userId', label: 'User Id', show: true, required: true },
  { id: 'gameName', label: 'Game Name', show: true },
  { id: 'returnToPlayer', label: 'RTP', show: true },
  { id: 'providerName', label: 'Provider Name', show: true },
  { id: 'actionType', label: 'Action Type', show: true },
  { id: 'amount', label: 'Cash', show: true },
  { id: 'nonCashAmount', label: 'Bonus', show: false },
  { id: 'amountType', label: 'Amount Type', show: false },
  { id: 'beforeBalance', label: 'Before Money', show: true },
  { id: 'afterBalance', label: 'After Money', show: true },
  { id: 'jackpotContribution', label: 'Jackpot Contribution', show: true },
  { id: 'status', label: 'Status', show: false },
  // Newly Added Columns
  { id: 'transactionId', label: 'Transaction Id', show: true },
  { id: 'gameIdentifier', label: 'Game Identifier', show: false },
  { id: 'tenantId', label: 'Tenant ID', show: false },
  { id: 'gameId', label: 'Game Id', show: true },
  { id: 'adminId', label: 'Admin ID', show: false },
  { id: 'currencyCode', label: 'Currency Code', show: false },
  { id: 'primaryCurrencyAmount', label: 'Primary Currency Amount', show: false },
  { id: 'conversionRate', label: 'Conversion Rate', show: false },
  { id: 'isSticky', label: 'Is Sticky', show: false },
  { id: 'userBonusId', label: 'User Bonus Id', show: false },
  { id: 'walletAmount', label: 'Wallet Amount', show: false },
  { id: 'walletNonCashAmount', label: 'Wallet NonCash Amount', show: false },
  { id: 'userEmail', label: 'User Email', show: false },
  { id: 'createdAt', label: 'Created At', show: true },
  { id: 'updatedAt', label: 'Updated At', show: true }
]

export const USER_CASINO_TRANSACTIONS_COLUMNS =
  CASINO_TRANSACTIONS_COLUMNS.filter((column) => column.id !== 'userId')

export const FINANCIAL_TRANSACTIONS_COLUMNS = [
  { id: 'transactionBankingId', label: 'ID', show: true },
  { id: 'paymentTransactionId', label: 'Transaction ID', show: true },
  { id: 'txRefId', label: 'TxRef Id', show: true },
  { id: 'actioneeEmail', label: 'Actionee Email', show: true },
  { id: 'targetId', label: 'Target ID', show: false },
  { id: 'portalName', label: 'Tenant', show: false },
  { id: 'license_id', label: 'License', show: false },
  { id: 'kycStatus', label: 'KYC Status', show: true },
  { id: 'countryCode', label: 'Country', show: true },
  { id: 'aggregator', label: 'Aggregator', show: true },
  { id: 'paymentProvider', label: 'Payment Provider', show: true },
  { id: 'paymentMethod', label: 'Payment Method', show: true },
  { id: 'initialPsp', label: 'Initial PSP', show: true },
  { id: 'finalPsp', label: 'Final PSP', show: true },
  { id: 'initialPspAccount', label: 'Initial PSP Account', show: false },
  { id: 'finalPspAccount', label: 'Final PSP Account', show: false },
  { id: 'group', label: 'Group', show: false },
  { id: 'successFee', label: 'TRX Success', show: true },
  { id: 'declinedFee', label: 'TRX Decline', show: true },
  { id: 'mdr', label: 'MDR%', show: true },
  { id: 'transactionFee', label: 'PSP Fee', show: true },
  { id: 'amount', label: 'Amount', show: true },
  { id: 'primaryAmount', label: 'Amount in EUR', show: true },
  { id: 'transactionType', label: 'Action', show: true },
  { id: 'actioneeType', label: 'Actionee Type', show: true },
  { id: 'status', label: 'Status', show: true },
  { id: 'txType', label: 'Tx Name', show: false },
  { id: 'currencyCode', label: 'Currency Code', show: false },
  { id: 'createdAt', label: 'Created At', show: true },
  { id: 'updatedAt', label: 'Updated At', show: true },
  { id: 'action', label: 'ACTION', show: true, required: true }
]

export const USER_FINANCIAL_TRANSACTIONS_COLUMNS =
  FINANCIAL_TRANSACTIONS_COLUMNS.map((column) => {
    if (column.id !== 'countryCode' && column.id !== 'kycStatus' && column.id != 'txType') {
      return column;
    }
    return { ...column, show: false };
  });

export const FILTER_BY = {
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt'
}
